import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

const HERO_IMAGE = "https://images.unsplash.com/photo-1762463176319-8416bf1e6a8e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwyfHxnb2xkJTIwYmFycyUyMHZhdWx0JTIwbHV4dXJ5fGVufDB8fHx8MTc3ODkzNjM0Mnww&ixlib=rb-4.1.0&q=85";

export default function HeroSection() {
  const scrollToContact = () => {
    const el = document.querySelector("#kontakt");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      data-testid="hero-section"
      className="relative min-h-[100svh] flex items-center pt-14 sm:pt-16 overflow-hidden"
    >
      <div className="absolute inset-0 z-0">
        <img
          src={HERO_IMAGE}
          alt="Goldbarren"
          className="w-full h-full object-cover"
          data-testid="hero-background-image"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0C1620]/95 via-[#0C1620]/85 to-[#0C1620]/60" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0C1620] via-transparent to-[#0C1620]/40" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-24 lg:py-32 relative z-10 w-full">
        <div className="max-w-3xl">
          <p className="uppercase text-[10px] sm:text-xs tracking-[0.2em] sm:tracking-[0.25em] text-[#C5993A] mb-4 sm:mb-6 animate-fade-in-up font-medium">
            Vermögensschutz mit Edelmetallen
          </p>

          <h1
            data-testid="hero-headline"
            className="font-heading text-3xl sm:text-5xl lg:text-7xl tracking-tight font-light text-white leading-[1.15] sm:leading-[1.1] mb-5 sm:mb-8 animate-fade-in-up animation-delay-200"
          >
            Ihr Geld verliert.{" "}
            <span className="block text-[#C5993A]">Jeden Tag. Still. Unbemerkt.</span>
          </h1>

          <p
            data-testid="hero-subheadline"
            className="text-sm sm:text-base lg:text-lg text-[#F0F4F8]/80 leading-relaxed max-w-2xl mb-8 sm:mb-12 animate-fade-in-up animation-delay-400 font-light"
          >
            Physische Edelmetalle sind die einzige Anlageklasse, die gleichzeitig Kaufkraft
            erhält, steuerfrei wächst, sofort liquidierbar ist und Ihr Vermögen außerhalb
            des Bankensystems schützt.
          </p>

          <div className="animate-fade-in-up animation-delay-600">
            <Button
              data-testid="hero-cta-button"
              onClick={scrollToContact}
              className="bg-gradient-to-r from-[#C5993A] to-[#8B6B20] text-white font-medium px-5 sm:px-8 py-5 sm:py-6 text-sm sm:text-base rounded hover:from-[#8B6B20] hover:to-[#C5993A] transition-all border-0 group w-full sm:w-auto"
            >
              Kostenloses Erstgespräch vereinbaren
              <ArrowRight className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform" />
            </Button>
          </div>

          <p className="mt-10 sm:mt-16 text-[#C5993A]/70 italic animate-fade-in-up animation-delay-800 font-heading text-base sm:text-lg">
            „Der beste Zeitpunkt, Vermögen zu schützen, war gestern. Der nächstbeste ist heute."
          </p>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#C5993A]/40 to-transparent" />
    </section>
  );
}
